import constantFactory from "@gaoding/constant-factory";

export const {
  MATERIAL_ICON,
  MATERIAL_ICON_LIST,
  MATERIAL_ICON_MAP,
  MATERIAL_ICON_ITEM_MAP,
} = constantFactory("MATERIAL_ICON", [
  {
    key: "JPG",
    label: "JPG",
    value: "jpg",
    icon: "ic_jpg",
    color: "#4648FF",
  },
  {
    key: "JPEG",
    label: "JPEG",
    value: "jpeg",
    icon: "ic_jpg",
    color: "#4648FF",
  },
  {
    key: "PNG",
    label: "PNG",
    value: "png",
    icon: "ic_png",
    color: "#774EEE",
  },
  {
    key: "PSD",
    label: "PSD",
    value: "psd",
    icon: "ic_ps",
    color: "#00B2FF",
  },
  {
    key: "PSB",
    label: "PSB",
    value: "psb",
    icon: "ic_ps",
    color: "#00B2FF",
  },
  {
    key: "EPS",
    label: "EPS",
    value: "eps",
    icon: "ic_ai",
    color: "#FF8C00",
  },
  {
    key: "AI",
    label: "AI",
    value: "ai",
    icon: "ic_ai",
    color: "#FF8C00",
  },
  {
    key: "AEP",
    label: "AEP",
    value: "aep",
    icon: "ic_ae",
    color: "#7441E0",
  },
  {
    key: "GIF",
    label: "GIF",
    value: "gif",
    icon: "ic_gif",
    color: "#4648FF",
  },
  {
    key: "PPT",
    label: "PPT",
    value: "ppt",
    icon: "ic_ppt",
    color: "#FF5F43",
  },
  {
    key: "PPTX",
    label: "PPTX",
    value: "pptx",
    icon: "ic_ppt",
    color: "#FF5F43",
  },
  {
    key: "C4D",
    label: "C4D",
    value: "c4d",
    icon: "ic_c4d",
    color: "#4648FF",
  },
  {
    key: "OBJ",
    label: "OBJ",
    value: "obj",
    icon: "ic_c4d",
    color: "#4648FF",
  },
  {
    key: "MP4",
    label: "MP4",
    value: "mp4",
    icon: "ic_mp4",
    color: "#68A9F7",
  },
  {
    key: "MOV",
    label: "MOV",
    value: "mov",
    icon: "ic_mp4",
    color: "#68A9F7",
  },
  {
    key: "SVG",
    label: "SVG",
    value: "svg",
    icon: "ic_svg",
    color: "#FF8C00",
  },
  {
    key: "DEFAULT",
    label: "源文件",
    value: "default",
    icon: "ic_other",
    color: "#FF8BC9",
  },
]);
